// let
let legend = {
  orient: 'vertical',
  x: 'left',
  y: 'center',
  data: ['成功', '失败(网络波动)', '执行中', '设备执行失败', '失败(超时)', '失败(未绑定设备)']
}

const fails = {
  0: '成功',
  1: '失败(网络波动)',
  2: '执行中',
  3: '设备执行失败',
  4: '失败(超时)',
  5: '失败(超时)',
  6: '失败(未绑定设备)',
}

export const chartOption = (param=[]) => {
  return {
    tooltip: {
      trigger: 'item',
      formatter: "{a} <br/>{b}: {c} ({d}%)"
    },
    legend,
    series: [{
        name: '状态',
        type: 'pie',
        selectedMode: 'single',
        radius: [0, '30%'],

        label: {
          normal: {
            position: 'inner'
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        data: [
          {
            value: param.filter((item) => item.status === 0).length,
            name: '成功'
          },{
            value: param.filter((item) => item.status === 2).length,
            name: '执行中'
          },{
            value: param.length - param.filter((item) => item.status === 0).length - param.filter((item) => item.status === 2).length,
            name: '失败',
            // selected: true
          },
        ]
      },
      {
        name: '状态',
        type: 'pie',
        radius: ['35%', '50%'],
        label: {
          position: 'inside'
        },
        data: [{
            value: param.filter((item) => item.status === 0).length,
            name: '成功'
          },
          {
            value: param.filter((item) => item.status === 2).length,
            name: '执行中'
          },
          {
            value: param.filter((item) => item.status === 1).length,
            name: '失败(网络波动)'
          },
          {
            value: param.filter((item) => item.status === 3).length,
            name: '设备执行失败'
          },
          {
            value: param.filter((item) => item.status === 5 || item.status === 4).length,
            name: '失败(超时)'
          },
          {
            value: param.filter((item) => item.status === 6).length,
            name: '失败(未绑定设备)'
          },
        ]
      }
    ]
  }
}

export const formatFailReason = (failStatu=0) => {
  return fails[failStatu]
}
// console.log(formatFailReason(3))